import i18n from 'i18next';

const getPlanFeatures = (activeTab, user) => {
  const t = (key) => i18n.t(key);

  // Determine which plan the user is currently on
  let userPlan = 'free';
  let userInterval = 'monthly';

  if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR) {
    userPlan = 'sme';
    userInterval = 'annual';
  } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR) {
    userPlan = 'basic';
    userInterval = 'annual';
  } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_YEAR) {
    userPlan = 'free';
    userInterval = 'annual';
  } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH) {
    userPlan = 'sme';
    userInterval = 'monthly';
  } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH) {
    userPlan = 'basic';
    userInterval = 'monthly';
  } else if (user?.activeSubscriptionPriceId === 'free' ||
    user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_MONTH) {
    userPlan = 'free';
    userInterval = 'monthly';
  }

  // Initialize plans with default values
  const planFeatures = {
    sme: {
      name: t('employer_plan.SME'),
      price: userInterval === 'annual' ? '$120' : '$120 /mo',
      features: [
        { name: 'Instant_Job_Activation', available: true },
        { name: 'Applications_Per_Job', available: true, value: '200' },
        { name: 'Monthly_Jobs', available: true, value: t('subscription.unlimited') },
        { name: 'Jobseekers_DB_Access', available: true },
        { name: 'View_Applicant_Profile', available: true },
        { name: 'Contact_Applicant', available: true },
        { name: 'View_Download_Resume', available: true }
      ],
      buttonText: 'Upgrade',
      buttonAction: null,
      isActive: false,
      // Only hide buttons for the wrong interval, don't hide the entire plan
      hideButton: (userInterval === 'annual' && activeTab === 'Monthly') || 
                  (userInterval === 'monthly' && activeTab === 'Annual')
    },
    basic: {
      name: t('employer_plan.Basic'),
      price: userInterval === 'annual' ? '$95' : '$95 /mo',
      features: [
        { name: 'Instant_Job_Activation', available: true },
        { name: 'Applications_Per_Job', available: true, value: '150' },
        { name: 'Monthly_Jobs', available: true, value: '3' },
        { name: 'Jobseekers_DB_Access', available: true },
        { name: 'View_Applicant_Profile', available: true },
        { name: 'Contact_Applicant', available: true },
        { name: 'View_Download_Resume', available: true }
      ],
      buttonText: 'Downgrade',
      buttonAction: null,
      isActive: false,
      // Only hide buttons for the wrong interval, don't hide the entire plan
      hideButton: (userInterval === 'annual' && activeTab === 'Monthly') || 
                  (userInterval === 'monthly' && activeTab === 'Annual')
    },
    free: {
      name: t('employer_plan.Free'),
      price: '$0',
      features: [
        { name: 'Instant_Job_Activation', available: false },
        { name: 'Applications_Per_Job', available: true, value: '15' },
        { name: 'Monthly_Jobs', available: true, value: '3' },
        { name: 'Jobseekers_DB_Access', available: false },
        { name: 'View_Applicant_Profile', available: false },
        { name: 'Contact_Applicant', available: false },
        { name: 'View_Download_Resume', available: false }
      ],
      buttonText: 'Downgrade',
      buttonAction: null,
      isActive: false,
      // Only hide buttons for the wrong interval, don't hide the entire plan
      hideButton: (userInterval === 'annual' && activeTab === 'Monthly') || 
                  (userInterval === 'monthly' && activeTab === 'Annual')
    }
  };

  // Set active plan and button text based on the active tab and user's plan
  if (activeTab === 'Annual') {
    // If user is on the same plan level but monthly interval, annual should be upgrade
    if (userPlan === 'basic' && userInterval === 'monthly') {
      planFeatures.basic.buttonText = t('subscription.upgrade');
    } else if (userPlan === 'sme' && userInterval === 'monthly') {
      planFeatures.sme.buttonText = t('subscription.upgrade');
    }

    if (user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR) {
      planFeatures.sme.buttonText = t('general.UI.pending')
    }
    else if (user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR) {
      planFeatures.basic.buttonText = t('general.UI.pending')
    }
    else if (user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_YEAR) {
      planFeatures.free.buttonText = t('general.UI.pending')
    } 


    // Mark the user's annual plan as active if they're on an annual plan
    if (userPlan === 'sme' && userInterval === 'annual') {
      planFeatures.sme.isActive = true;
      planFeatures.sme.buttonText = t('subscription.active');
    } else if (userPlan === 'basic' && userInterval === 'annual') {
      planFeatures.basic.isActive = true;
      planFeatures.basic.buttonText = t('subscription.active');
      planFeatures.sme.buttonText = t('subscription.upgrade');
      planFeatures.free.buttonText = t('subscription.downgrade');
    } else if (userPlan === 'free' && userInterval === 'annual') {
      planFeatures.free.isActive = true;
      planFeatures.free.buttonText = t('subscription.active');
      planFeatures.basic.buttonText = t('subscription.upgrade');
      planFeatures.sme.buttonText = t('subscription.upgrade');
    }
  } else if (activeTab === 'Monthly') {
    // If user is on the same plan level but annual interval, monthly should be downgrade
    if (userPlan === 'basic' && userInterval === 'annual') {
      planFeatures.basic.buttonText = t('subscription.downgrade');
    } else if (userPlan === 'sme' && userInterval === 'annual') {
      planFeatures.sme.buttonText = t('subscription.downgrade');
    }

    if (user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH) {
      planFeatures.sme.buttonText = t('general.UI.pending')
    }
    else if (user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH) {
      planFeatures.basic.buttonText = t('general.UI.pending')
    }
    else if (user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_MONTH) {
      planFeatures.free.buttonText = t('general.UI.pending')
    } 
    if (userPlan === 'sme' && userInterval === 'monthly') {
      planFeatures.sme.isActive = true;
      planFeatures.sme.buttonText = t('subscription.active');
    } else if (userPlan === 'basic' && userInterval === 'monthly') {
      planFeatures.basic.isActive = true;
      planFeatures.basic.buttonText = t('subscription.active');
      planFeatures.sme.buttonText = t('subscription.upgrade');
      planFeatures.free.buttonText = t('subscription.downgrade');
    } else if (userPlan === 'free' && userInterval === 'monthly') {
      planFeatures.free.isActive = true;
      planFeatures.free.buttonText = t('subscription.active');
      planFeatures.basic.buttonText = t('subscription.upgrade');
      planFeatures.sme.buttonText = t('subscription.upgrade');
    }
  }

  // Dynamically set prices from user object if available
  if (user?.subscription_price_sme_basic_for_1_month) {
    planFeatures.sme.price = activeTab === 'Annual'
      ? `$${user.subscription_price_sme_basic_for_1_year?.unit_amount / 100}`
      : `$${user.subscription_price_sme_basic_for_1_month?.unit_amount / 100} /mo`;

    planFeatures.basic.price = activeTab === 'Annual'
      ? `$${user.subscription_price_basic_for_1_year?.unit_amount / 100}`
      : `$${user.subscription_price_basic_for_1_month?.unit_amount / 100} /mo`;
  }

  return planFeatures;
};

export default getPlanFeatures; 